import { ShippingPolicyState } from '@/lib/types/shipping-policy';
import { atom } from 'jotai';

const defaultShippingPolicy: ShippingPolicyState = {
  freeShippingRules: [],
  deliveryOfferedNumberOfDays: null,
  pickupPointNetwork: null,
  basicFrPickupPointDeliveryPrice: null,
  allShippingFeesZero: false,
};

export const shippingPolicyState = atom<ShippingPolicyState>(
  defaultShippingPolicy
);
